import { Animate, Card, Form, ShortCodes, TitleRow, useNavigate } from 'components/lib'
import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import EmailEditor from 'react-email-editor'
import './style.scss'

function EditEmail() {
    const { id } = useParams()

    const editorRef = useRef(null)

    const { data, isLoading } = useQuery({
        queryKey: ['email', id],
        queryFn: () => axios.get(`/api/email/${id}`).then(res => res.data?.data),
    })

    const loadDesign = () => {
        if (editorRef.current && editorRef.current.editor) {
            editorRef.current.editor.loadDesign(data?.design);
        } else {
            console.error("EmailEditor ref or editor instance not available in onReady");
        }
    };

    const getEmailHTML = () => new Promise((resolve) => {
        editorRef.current.editor.exportHtml((data) => {
            resolve(data)
        })
    })

    return (
        <Animate>
            <Card loading={isLoading}>
                <EmailEditor
                    ref={editorRef}
                    onReady={loadDesign}
                />

                <div className='mt-5'>
                    <TitleRow title='Email Settings' />
                    <div className="grid grid-cols-2 gap-4">
                        <Form
                            inputs={{
                                template: {
                                    type: 'text',
                                    label: 'Template Name',
                                    placeholder: 'Template Name',
                                    value: data?.template,
                                    required: true
                                },
                                subject: {
                                    type: 'text',
                                    label: 'Subject',
                                    placeholder: 'Subject',
                                    value: data?.subject,
                                    required: true
                                },
                                type: {
                                    type: 'select',
                                    label: 'Type',
                                    placeholder: 'Type',
                                    default: data?.type,
                                    options: [
                                        { label: 'Critical', value: 'critical' },
                                        { label: 'Updates', value: 'updates' },
                                        { label: 'News', value: 'news' }
                                    ],
                                    required: true
                                },
                                from: {
                                    type: 'text',
                                    label: 'Email From',
                                    placeholder: 'Email From',
                                    value: data?.from,
                                    required: true
                                }
                            }}
                            bodyPromise={getEmailHTML}
                            method='PUT'
                            url={`/api/email/${id}`}
                            buttonText='Save Email'
                            callback={() => {
                                window.location.href = '/emails'
                            }}
                        />
                        <ShortCodes
                            codes={[
                                { code: '{business_name}', label: 'Business Name', desc: '* Required, please add your business name to the message' },
                                { code: '{address}', label: 'Address', desc: 'Business address' },
                                { code: '{phone}', label: 'Phone Number', desc: 'Business phone number' },
                                { code: '{hours}', label: 'Hours', desc: 'Hours of operation' },
                                { code: '{city}', label: 'City', desc: 'Business City' },
                                { code: '{website_link}', label: 'Website Link', desc: 'Website link to your business website. All links will be shortened.' },
                                { code: '{working_hours_link}', label: 'Working Hours Link', desc: 'Link to your online ordering, menu, Calendly, or any other relevant information. All links will be shortened.' },
                                { code: '{working_hours_link_2}', label: 'Working Hours Link 2', desc: 'Any additional links you would like to provide? All links will be shortened.' },
                                { code: '{after_hours_link}', label: 'After Hours Link', desc: 'Link to your online ordering, menu, Calendly, or any other relevant information. All links will be shortened.' },
                                { code: '{after_hours_link_2}', label: 'After Hours Link 2', desc: 'Any additional links you would like to provide? All links will be shortened.' }
                            ]}
                        />
                    </div>
                </div>
            </Card>
        </Animate>
    )
}

export default EditEmail